module.exports = __webpack_public_path__ + "img/C00028.48055bb8.png";